module.exports = __webpack_public_path__ + "img/JiB_banner.d3e04e5c.webp";